export default "<!-- Page Content -->\n<div class=\"flex-grow-1 outlet-wrapper\">\n  <router-outlet></router-outlet>\n</div>\n";